import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { customerResource } from '../../system/customerManage/request';
import { allMessageList, sceneVariableResource } from '../systemScene/request';
import { pushScenarioResource, structureResource, accountResource, productNameResource, auditFlowResource, reviewerCcResource, sceneConfigList, messageConfigStore, messageConfigDetail, messageConfigEdit } from './request';
import topTitle from '@/components/title';
import mail from '../systemScene/components/mail.vue';
import message from '../systemScene/components/message.vue';
import email from '../systemScene/components/email.vue';
import variable from '../systemScene/components/variable.vue';
const languageSequence = ['ZH', 'CHT', 'EN', 'FRA', 'SPA'];
export default {
  data() {
    return {
      form: {
        customerId: undefined,
        structureType: undefined,
        associationId: [],
        messageCategory: undefined,
        pushScenario: undefined
      },
      sceneConfigId: [],
      customersList: [],
      structureList: [],
      structureListTree: [],
      pushScenarioList: [],
      plainOptions: [{
        label: this.$t('站内信'),
        value: 'INTERNAL_MAIL',
        disabled: false
      }, {
        label: this.$t('短信'),
        value: 'NOTE',
        disabled: false
      }, {
        label: this.$t('邮件'),
        value: 'EMAIL',
        disabled: false
      }],
      collapsesMap: {
        ZH: '简体中文',
        CHT: '繁体中文',
        EN: '英语',
        FRA: '法语',
        SPA: '西班牙语'
      },
      variables: {},
      auditFlowList: [],
      auditNodeLists: [],
      accountTreeData: [],
      productList: [],
      form1: {
        auditFlowId: undefined,
        auditFlowNodeId: [],
        insuranceId: undefined,
        usersId: [],
        mobile: undefined,
        email: undefined
      },
      props: {
        multiple: true
      },
      receiverConfig: {
        AUDIT_FLOW: [{
          btnCheck: false,
          btnName: '审核人',
          hasSelect: false,
          formKey: 'REVIEWER',
          selectValue: [],
          selectOptions: [],
          selectDisabled: false,
          mode: 'multiple'
        }, {
          btnCheck: false,
          btnName: '抄送人',
          hasSelect: false,
          formKey: 'CC',
          selectValue: [],
          selectOptions: [],
          selectDisabled: false,
          mode: 'multiple'
        }, {
          btnCheck: false,
          btnName: '发起人',
          hasSelect: false,
          formKey: 'SPONSOR'
        }],
        INSURE: [{
          btnCheck: false,
          btnName: '投保人',
          hasSelect: false,
          formKey: 'INSURED'
        }, {
          btnCheck: false,
          btnName: '被保人',
          hasSelect: false,
          formKey: 'ASSURED'
        }, {
          btnCheck: false,
          btnName: '录单管理员',
          hasSelect: false,
          formKey: 'RECORDING_ADMIN'
        }],
        TASK_LIST: [{
          btnCheck: false,
          btnName: '任务管理员',
          hasSelect: false,
          formKey: 'TASK_ADMIN'
        }],
        SURRENDER_INSURANCE: [{
          btnCheck: false,
          btnName: '录单管理员',
          hasSelect: false,
          formKey: 'RECORDING_ADMIN'
        }]
      },
      attachmentVariable: [],
      internalMailSceneList: [],
      noteSceneList: [],
      emailSceneList: [],
      emailSceneObj: null,
      noteSceneObj: null,
      internalMailSceneObj: null,
      messageLists: [],
      accountObj: {},
      isEdit: false,
      isCopy: false,
      saveLoading: false
    };
  },
  components: {
    topTitle,
    mail,
    variable,
    message,
    email
  },
  computed: {
    dataRule() {
      return {
        customerId: [{
          required: true,
          message: this.$t('请选择') + this.$t('客户名称'),
          trigger: 'change'
        }],
        structureType: [{
          required: true,
          validator: this.validateStructure,
          trigger: 'change'
        }],
        messageCategory: [{
          required: true,
          message: this.$t('请选择') + this.$t('消息类别'),
          trigger: 'change'
        }],
        pushScenario: [{
          required: true,
          message: this.$t('请选择') + this.$t('推送场景'),
          trigger: 'change'
        }]
      };
    },
    form1Rule() {
      return {
        auditFlowId: [{
          required: true,
          message: this.$t('请选择') + this.$t('审核流名称'),
          trigger: 'change'
        }],
        auditFlowNodeId: [{
          required: true,
          message: this.$t('请选择') + this.$t('审核流节点'),
          trigger: 'change'
        }],
        insuranceId: [{
          required: true,
          message: this.$t('请选择') + this.$t('产品名称'),
          trigger: 'change'
        }]
      };
    },
    pushScenarioPlaceholder() {
      return this.form.messageCategory ? `${this.$t('请选择') + this.$t('推送场景')}` : `${this.$t('请先选择消息类别')}`;
    },
    structureTypePlaceholder() {
      return this.form.customerId ? `${this.$t('请选择') + this.$t('适用架构')}` : `${this.$t('请先选择客户名称')}`;
    },
    isAuditFlow() {
      return this.form.messageCategory === 'AUDIT_FLOW';
    },
    messageCategoryPlaceholder() {
      return this.form.customerId ? `${this.$t('请选择') + this.$t('消息类别')}` : `${this.$t('请先选择客户名称')}`;
    },
    computedAccountTreeData() {
      let loop = data => {
        if (Array.isArray(data) && data.length) {
          return data.map(item => {
            if (item.value === 'ALL') {
              item.label = this.$t('全部');
            } else if (item.label === '系统管理员') {
              item.label = this.$t('系统管理员');
            }
            if (item.children && item.children.length) {
              item.children = loop(item.children);
            }
            return item;
          });
        } else {
          return [];
        }
      };
      return loop(this.accountTreeData);
    }
  },
  created() {
    customerResource().then(res => {
      this.customersList = res;
    });
    if (this.$route.params.id != -1) {
      this.isEdit = true;
    } else {
      this.isEdit = false;
    }
    if (this.$route.params.copyId != -1) {
      this.isCopy = true;
    } else {
      this.isCopy = false;
    }
    if (this.isEdit || this.isCopy) {
      this.getDetail();
    } else {
      this.getAccountResource();
    }
  },
  mounted() {
    this.copyConfig = JSON.parse(JSON.stringify(this.receiverConfig));
    this.getMessages();
  },
  methods: {
    validateStructure(rule, value, callback) {
      var _this$form$associatio;
      if (!this.form.structureType) {
        callback(new Error(this.$t('请选择') + this.$t('适用架构')));
      } else if (this.form.structureType !== 'ALL' && !this.form.associationId || this.form.structureType && this.form.structureType !== 'ALL' && ((_this$form$associatio = this.form.associationId) === null || _this$form$associatio === void 0 ? void 0 : _this$form$associatio.length) === 0) {
        callback(new Error(this.$t('请选择') + this.$t('适用架构')));
      } else {
        callback();
      }
    },
    getDetail() {
      let messageConfigId = this.isEdit ? this.$route.params.id : this.$route.params.copyId;
      console.log('valwatch', this.$route.params.id, this.$route.params.copyId, messageConfigId, this.isEdit);
      let params = {
        messageConfigId
      };
      messageConfigDetail(params).then(res => {
        this.form.customerId = res.customerId;
        // customerId改变后的操作 会请求架构资源
        this.customerIdChange(this.form.customerId);
        this.getAccountResource();
        this.form.structureType = res.structureType;
        this.form.associationId = res.associationId ? String(res.associationId).split(',') : [];
        this.form.messageCategory = res.messageCategory;
        //设置消息类别后  设置事件配置的回显
        this.setEventConfig(res.eventConfig);
        this.form.pushScenario = res.pushScenario;
        pushScenarioResource({
          messageCategory: this.form.messageCategory
        }).then(pushScenarioList => {
          this.pushScenarioList = pushScenarioList;
          this.pushScenarioChange(this.form.pushScenario);
          //设置自定义接受对象回显
          this.setCustomize(res.customize);
          //设置消息配置的回显
          this.setMessageConfig(res.messageConfig);
        });
      });
    },
    async setEventConfig(eventConfig) {
      //设置事件配置回显
      if (this.form.messageCategory === 'AUDIT_FLOW') {
        //审核流相关 请求审核流资源
        await this.getAuditFlowResource();
      } else if (this.form.messageCategory === 'INSURE' || this.form.messageCategory === 'SURRENDER_INSURANCE') {
        //投保相关 退保相关 请求产品名称资源
        await this.getProductNameResource();
      }
      let eventConfigObj = JSON.parse(eventConfig);
      this.form1.auditFlowId = eventConfigObj.auditFlowId || undefined;
      if (this.form1.auditFlowId) {
        this.auditFlowIdChange(this.form1.auditFlowId);
      }
      this.form1.insuranceId = eventConfigObj.insuranceId || undefined;
      this.form1.auditFlowNodeId = eventConfigObj.auditFlowNodeId || [];
      if (this.form1.auditFlowNodeId) {
        await this.getflowValue();
      }
      let receiveObject = eventConfigObj.receiveObject;
      receiveObject.forEach(item => {
        let currentCategory = this.receiverConfig[this.form.messageCategory].filter(category => category.formKey === item.type);
        if (item.userId === '') {
          currentCategory[0].btnCheck = true;
        } else {
          var _item$userId;
          currentCategory[0].btnCheck = false;
          currentCategory[0].selectValue = item.userId ? (_item$userId = item.userId) === null || _item$userId === void 0 ? void 0 : _item$userId.split(',') : [];
        }
      });
      console.log(JSON.stringify(this.receiverConfig), this.receiverConfig, 'this.receiverConfig');
    },
    getflowValue() {
      if (this.form1.auditFlowNodeId.length === 1) {
        return new Promise(resolve => {
          let params = {
            auditFlowNodeId: this.form1.auditFlowNodeId[0]
          };
          reviewerCcResource(params).then(res => {
            let reviewer = res.reviewer ? Object.keys(res.reviewer) : [];
            let CC = res.cc ? Object.keys(res.cc) : [];
            this.receiverConfig.AUDIT_FLOW.forEach(item => {
              item.selectOptions = [];
              item.selectValue = [];
              item.selectDisabled = false;
              if (item.formKey === 'REVIEWER') {
                item.hasSelect = true;
                item.selectOptions = reviewer.map((item, index) => {
                  return {
                    id: item,
                    name: res.reviewer[item]
                  };
                });
              } else if (item.formKey === 'CC') {
                item.hasSelect = true;
                item.selectOptions = CC.map(item => {
                  return {
                    id: item,
                    name: res.cc[item]
                  };
                });
              }
              resolve();
            });
          });
        });
      } else {
        this.receiverConfig.AUDIT_FLOW.forEach(item => {
          item.selectOptions = [];
          item.selectValue = [];
          item.hasSelect = false;
          item.selectDisabled = true;
        });
      }
    },
    setCustomize(customize) {
      //设置自定义接收对象回显
      let customizeObj = JSON.parse(customize) || {};
      this.form1.usersId = [];
      let user = customizeObj.user;
      user.forEach(item => {
        let customerId = item.customerId;
        let userId = item.userId ? item.userId.split(',') : '';
        userId && Array.isArray(userId) && userId.forEach(item => {
          let obj = [customerId];
          obj.push(item);
          this.form1.usersId.push(obj);
        });
      });
      //设置自定义账户的数据的互斥disabled关系
      this.changeAccount(this.form1.usersId);
      this.form1.mobile = customizeObj.mobile ? customizeObj.mobile.join(';') : '';
      this.form1.email = customizeObj.email ? customizeObj.email.join(';') : '';
    },
    setMessageConfig(messageConfig) {
      let messageConfigObj = messageConfig;
      this.sceneConfigId = [];
      this.messageConfigIds = {};
      messageConfigObj.forEach(item => {
        if (item.sceneConfigId) {
          this.messageConfigIds[item.type] = item.sceneConfigId;
        }
        if (item.type === 'INTERNAL_MAIL') {
          this.sceneConfigId.push('INTERNAL_MAIL');
          this.internalMailSceneObj = item;
        } else if (item.type === 'NOTE') {
          this.sceneConfigId.push('NOTE');
          this.noteSceneObj = item;
        } else if (item.type === 'EMAIL') {
          this.sceneConfigId.push('EMAIL');
          this.emailSceneObj = item;
        }
      });
    },
    clearMessageConfig() {
      this.sceneConfigId = [];
      this.emailSceneObj = null;
      this.noteSceneObj = null;
      this.internalMailSceneObj = null;
      this.plainOptions.forEach(item => {
        item.disabled = false;
      });
    },
    getMessages() {
      //获取短信列表
      allMessageList({}).then(res => {
        this.messageLists = res;
      });
    },
    getSceneConfigList(sceneListId) {
      let email = {
        sceneListId,
        type: 'EMAIL'
      };
      sceneConfigList(email).then(res => {
        if (res.length === 0) {
          this.plainOptions[2].disabled = true;
        }
        let languageMap = {};
        res.forEach(item => {
          languageMap[item.language] = item;
        });
        let sequence = [];
        languageSequence.forEach(item => {
          let current = languageMap[item];
          if (current && Object.keys(current).length > 0) {
            sequence.push(current);
          }
        });
        this.emailSceneList = sequence.map(item => {
          return {
            ...item,
            languageTitle: this.collapsesMap[item.language]
          };
        });
      });
      let note = {
        sceneListId,
        type: 'NOTE'
      };
      sceneConfigList(note).then(res => {
        if (res.length === 0) {
          this.plainOptions[1].disabled = true;
        }
        let languageMap = {};
        res.forEach(item => {
          languageMap[item.language] = item;
        });
        let sequence = [];
        languageSequence.forEach(item => {
          let current = languageMap[item];
          if (current && Object.keys(current).length > 0) {
            sequence.push(current);
          }
        });
        this.noteSceneList = sequence.map(item => {
          return {
            ...item,
            languageTitle: this.collapsesMap[item.language]
          };
        });
      });
      let internalMail = {
        sceneListId,
        type: 'INTERNAL_MAIL'
      };
      sceneConfigList(internalMail).then(res => {
        if (res.length === 0) {
          this.plainOptions[0].disabled = true;
        }
        let languageMap = {};
        res.forEach(item => {
          languageMap[item.language] = item;
        });
        let sequence = [];
        languageSequence.forEach(item => {
          let current = languageMap[item];
          if (current && Object.keys(current).length > 0) {
            sequence.push(current);
          }
        });
        this.internalMailSceneList = sequence.map(item => {
          return {
            ...item,
            languageTitle: this.collapsesMap[item.language]
          };
        });
      });
    },
    getProductNameResource() {
      let params = {
        customerId: this.form.customerId
      };
      return new Promise(resolve => {
        productNameResource(params).then(res => {
          this.productList = [{
            id: 'ALL',
            name: '全部'
          }, ...res];
          resolve();
        });
      });
    },
    changeCheck(item) {
      // 附件变量点击切换
      if (!item.btnCheck) {
        this.$set(item, 'selectValue', []);
      }
      this.$set(item, 'btnCheck', !item.btnCheck);
    },
    getAccountResource() {
      accountResource({}).then(res => {
        let loop = data => {
          if (Array.isArray(data) && data.length) {
            return data.map(item => {
              let obj = {
                label: item.name || item.nickName,
                value: item.id,
                disabled: false
              };
              if (item.children && item.children.length) {
                obj.children = loop(item.children);
                obj.children.unshift({
                  label: '全部',
                  value: 'ALL',
                  disabled: false
                });
              }
              return obj;
            });
          } else {
            return [];
          }
        };
        let data = [{
          label: '系统管理员',
          value: '0ffdf',
          children: [{
            label: '全部',
            value: 'ALL'
          }]
        }];
        let admin = res.admin.map(item => {
          return {
            label: item.nickName,
            value: item.id
          };
        });
        data[0].children.push(...admin);
        let customerAdmin = loop(res.customerAdmin);
        data.push(...customerAdmin);
        this.accountTreeData = data;
      });
    },
    onChange(checkedValues) {
      this.plainOptions.forEach(item => {
        if (this.sceneConfigId.indexOf(item.value) === -1) {
          if (item.value === 'INTERNAL_MAIL') {
            this.internalMailSceneObj = {};
          } else if (item.value === 'NOTE') {
            this.noteSceneObj = {};
          } else if (item.value === 'EMAIL') {
            this.emailSceneObj = {};
          }
          if (this.edit) {
            this.messageConfigIds[item.value] = undefined;
          }
        }
      });
    },
    clearEventConfig() {
      this.form1.auditFlowId = undefined;
      this.form1.auditFlowNodeId = [];
      this.form1.insuranceId = undefined;
      this.form1.usersId = [];
      this.changeAccount([]);
      this.form1.mobile = undefined;
      this.form1.email = undefined;
      this.receiverConfig = JSON.parse(JSON.stringify(this.copyConfig));
    },
    flowTypeIdChange(value, isEdit) {
      //清除事件配置
      this.clearEventConfig();
      this.form.pushScenario = undefined;
      this.pushScenarioList = [];
      if (value) {
        pushScenarioResource({
          messageCategory: value
        }).then(res => {
          this.pushScenarioList = res;
        });
      }
      if (value === 'AUDIT_FLOW') {
        //审核流相关 请求审核流资源
        this.getAuditFlowResource();
      } else if (value === 'INSURE' || value === 'SURRENDER_INSURANCE') {
        //投保相关 退保相关 请求产品名称资源
        this.getProductNameResource();
      }
    },
    auditFlowIdChange(value) {
      //审核流名称发生改变
      if (value !== 'ALL') {
        let selectItem = this.auditFlowList.find(item => item.id === value);
        this.auditNodeLists = (selectItem === null || selectItem === void 0 ? void 0 : selectItem.node.map((item, index) => {
          // item.echoName = `第${index + 1}节点-${item.name}`;
          item.name = `第${index + 1}节点-${item.name}`;
          return item;
        })) || [];
      } else {
        this.auditNodeLists = [];
      }
      this.receiverConfig = JSON.parse(JSON.stringify(this.copyConfig));
      this.form1.auditFlowNodeId = [];
    },
    getAuditFlowResource() {
      //获取审核流资源
      let params = {
        customerId: this.form.customerId
      };
      return new Promise(resolve => {
        auditFlowResource(params).then(res => {
          this.auditFlowList = res;
          this.auditFlowList.unshift({
            id: 'ALL',
            name: '全部'
          });
          resolve();
        });
      });
    },
    structureTypeChange() {
      this.form.associationId = undefined;
      this.$refs.dataFrom.validateField('structureType');
    },
    associationIdChange() {
      this.$refs.dataFrom.validateField('structureType');
    },
    customerIdChange(value) {
      //清空事件配置id
      this.clearEventConfig();
      this.form.structureType = undefined;
      this.form.associationId = undefined;
      this.structureList = [];
      this.structureListTree = [];
      this.form.messageCategory = undefined;
      this.form.pushScenario = undefined;
      if (value || value === 0) {
        this.getStructureResource();
      }
    },
    collectAccountObj() {
      this.accountObj = {};
      this.form1.usersId.forEach(item => {
        var _this$accountObj$item;
        if (((_this$accountObj$item = this.accountObj[item[0]]) === null || _this$accountObj$item === void 0 ? void 0 : _this$accountObj$item.length) > 0) {
          this.accountObj[item[0]].push(item[1]);
        } else {
          this.accountObj[item[0]] = [item[1]];
        }
      });
    },
    changeAccount(value) {
      this.collectAccountObj();
      this.accountTreeData.forEach(item => {
        if (item.children) {
          let selectValue = this.accountObj[item.value];
          item.children.forEach(child => {
            if (selectValue && (selectValue === null || selectValue === void 0 ? void 0 : selectValue.indexOf('ALL')) !== -1 && child.value !== 'ALL') {
              child.disabled = true;
            } else if (selectValue && (selectValue === null || selectValue === void 0 ? void 0 : selectValue.length) > 0 && (selectValue === null || selectValue === void 0 ? void 0 : selectValue.indexOf('ALL')) === -1 && child.value === 'ALL') {
              child.disabled = true;
            } else {
              child.disabled = false;
            }
          });
        }
      });
      this.accountTreeData = [...this.accountTreeData];
    },
    getStructureResource() {
      //获取架构资源
      let params = {
        customerId: this.form.customerId
      };
      let loop = data => {
        return data.map(item => {
          let obj = {
            title: item.name,
            value: item.id,
            name: item.name,
            id: item.id,
            label: item.name,
            disabled: true,
            key: item.id
          };
          if (item.children && item.children.length) {
            obj.children = loop(item.children);
          }
          if (item.userInfo && item.userInfo.length > 0) {
            obj.children = obj.children || [];
            item.userInfo.forEach(userItem => {
              let user = {
                title: userItem.nickName,
                value: userItem.userId,
                name: userItem.nickName,
                id: userItem.userId,
                label: userItem.nickName,
                key: userItem.userId
              };
              obj.children.push(user);
            });
          }
          return obj;
        });
      };
      const loop2 = data => {
        return data.map(item => {
          let obj = {
            title: item.name,
            value: item.id,
            name: item.name,
            id: item.id,
            label: item.name,
            key: item.id
          };
          if (item.children && item.children.length) {
            obj.children = loop2(item.children);
          }
          return obj;
        });
      };
      structureResource(params).then(res => {
        this.structureList = Array.isArray(res) && res !== null && res !== void 0 && res.length ? loop2(res) : [];
        this.structureListTree = Array.isArray(res) && res !== null && res !== void 0 && res.length ? loop(res) : [];
      });
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    pushScenarioChange(key) {
      //清空事件配置数据
      this.clearMessageConfig();
      this.sceneConfigId = '';
      if (key) {
        var _this$pushScenarioLis;
        let sceneListId = (_this$pushScenarioLis = this.pushScenarioList.find(item => item.pushScenario === key)) === null || _this$pushScenarioLis === void 0 ? void 0 : _this$pushScenarioLis.sceneListId;
        this.getVariables(sceneListId);
        this.getSceneConfigList(sceneListId);
      }
    },
    useTemplate(item, type) {
      // 使用模板设置回显对象
      let key = type + 'SceneObj';
      this[key] = {
        ...item
      };
    },
    getVariables(sceneListId) {
      //获取变量资源
      this.attachmentVariable = [];
      sceneVariableResource({
        sceneListId
      }).then(res => {
        if (res) {
          this.variables = res;
          let annexe = JSON.parse(JSON.stringify(res.annexe));
          this.attachmentVariable = annexe && Array.isArray(annexe) && annexe.map(item => {
            item.isCheck = false;
            return item;
          });
        }
      });
    },
    auditFlowNodeIdChange(value) {
      //审核流节点选择后 如果仅选中1个节点 请求审核人抄送人数据
      if (value.length === 1) {
        let params = {
          auditFlowNodeId: value[0]
        };
        reviewerCcResource(params).then(res => {
          let reviewer = res.reviewer ? Object.keys(res.reviewer) : [];
          let CC = res.cc ? Object.keys(res.cc) : [];
          this.receiverConfig.AUDIT_FLOW.forEach(item => {
            item.selectOptions = [];
            item.selectValue = [];
            item.selectDisabled = false;
            if (item.formKey === 'REVIEWER') {
              item.hasSelect = true;
              item.selectOptions = reviewer.map((item, index) => {
                return {
                  id: item,
                  name: res.reviewer[item]
                };
              });
            } else if (item.formKey === 'CC') {
              item.hasSelect = true;
              item.selectOptions = CC.map(item => {
                return {
                  id: item,
                  name: res.cc[item]
                };
              });
            }
          });
        });
      } else {
        this.receiverConfig.AUDIT_FLOW.forEach(item => {
          item.selectOptions = [];
          item.selectValue = [];
          item.hasSelect = false;
          item.selectDisabled = true;
        });
      }
    },
    checkAllForm() {
      //校验所有的form
      let formStatus = true;
      this.$refs.dataFrom.validate(valid => {
        if (!valid) {
          formStatus = false;
        }
      });
      this.$refs.form1.validate(valid => {
        if (!valid) {
          formStatus = false;
        }
      });
      this.sceneConfigId.forEach(item => {
        if (item === 'INTERNAL_MAIL') {
          let childForm = this.$refs.internalMailForm;
          childForm.$refs.ruleForm.validate(valid => {
            if (!valid) {
              formStatus = false;
            }
          });
        } else if (item === 'NOTE') {
          let childForm = this.$refs.noteForm;
          childForm.$refs.ruleForm.validate(valid => {
            if (!valid) {
              formStatus = false;
            }
          });
        } else if (item === 'EMAIL') {
          let childForm = this.$refs.emailForm;
          childForm.$refs.emailForm.validate(valid => {
            if (!valid) {
              formStatus = false;
            }
          });
        }
      });
      return formStatus;
    },
    save() {
      let formStatus = this.checkAllForm();
      if (formStatus) {
        var _this$form$associatio2;
        let checkReceiveObject = this.checkReceiveObject();
        if (checkReceiveObject) {
          this.$message.error(this.$t('请添加接收对象'));
          return;
        }
        let params = {
          customerId: this.form.customerId,
          structureType: this.form.structureType,
          associationId: ((_this$form$associatio2 = this.form.associationId) === null || _this$form$associatio2 === void 0 ? void 0 : _this$form$associatio2.join(',')) || '',
          messageCategory: this.form.messageCategory,
          pushScenario: this.form.pushScenario
        };
        //处理事件配置的参数
        let eventConfig = this.formatEventConfig();
        params.eventConfig = JSON.stringify(eventConfig);
        params.remark = this.getRemark();
        //处理自定义接收对象的参数
        let customize = this.formatCustomize();
        params.customize = customize ? JSON.stringify(customize) : '';
        //处理消息配置区域的提交参数
        if (!this.checkMessgaeFileUploadComplate()) {
          this.$message.error(this.$t('文件上传中，请稍后再试'));
          return;
        }
        let messageConfig = this.formatMessageConfig();
        params.messageConfig = JSON.stringify(messageConfig);
        let saveFunction = this.isEdit ? messageConfigEdit : messageConfigStore;
        if (this.isEdit) {
          params.messageConfigId = this.$route.params.id;
        }
        this.saveLoading = true;
        saveFunction(params).then(res => {
          if (res.messageConfigId) {
            this.$router.push({
              name: 'customerMessageManagement'
            });
          }
          this.$message.success(this.$t('保存成功'));
        }).finally(() => {
          this.saveLoading = false;
        });
      }
    },
    checkMessgaeFileUploadComplate() {
      let flag = true;
      this.sceneConfigId.forEach(item => {
        let formData;
        if (item === 'INTERNAL_MAIL') {
          formData = this.$refs.internalMailForm.form;
        } else if (item === 'EMAIL') {
          formData = this.$refs.emailForm.form;
        }
        if (formData && Object.keys(formData).length > 0) {
          let fileList = formData.fileList;
          fileList && Array.isArray(fileList) && fileList.forEach(item => {
            if (item.status !== 'done') {
              flag = false;
            }
          });
        }
      });
      return flag;
    },
    formatMessageConfig() {
      let messageConfig = [];
      //处理消息配置区域的提交参数
      this.sceneConfigId.forEach(item => {
        if (item === 'INTERNAL_MAIL') {
          let obj = this.getInternalMailFormData();
          messageConfig.push(obj);
        } else if (item === 'NOTE') {
          let obj = this.getNoteForm();
          messageConfig.push(obj);
        } else if (item === 'EMAIL') {
          let obj = this.getEmailForm();
          messageConfig.push(obj);
        }
      });
      return messageConfig;
    },
    formatCustomize() {
      var _this$form, _this$form1$mobile, _this$form2, _this$form3;
      //处理自定义接收对象的参数
      let customize = {
        mobile: (_this$form = this.form1) !== null && _this$form !== void 0 && _this$form.mobile ? (_this$form1$mobile = this.form1.mobile) === null || _this$form1$mobile === void 0 ? void 0 : _this$form1$mobile.trim().split(';') : [],
        email: (_this$form2 = this.form1) !== null && _this$form2 !== void 0 && _this$form2.email ? (_this$form3 = this.form1) === null || _this$form3 === void 0 || (_this$form3 = _this$form3.email) === null || _this$form3 === void 0 ? void 0 : _this$form3.trim().split(';') : []
      };
      this.collectAccountObj();
      let user = [];
      Object.keys(this.accountObj).forEach(item => {
        var _this$accountObj$item2;
        user.push({
          customerId: item,
          userId: (_this$accountObj$item2 = this.accountObj[item]) === null || _this$accountObj$item2 === void 0 ? void 0 : _this$accountObj$item2.join(',')
        });
      });
      customize.user = user;
      return customize;
    },
    formatEventConfig() {
      //处理事件配置的参数
      let eventConfig = {
        auditFlowId: this.form1.auditFlowId || '',
        auditFlowNodeId: this.form1.auditFlowNodeId || '',
        insuranceId: this.form1.insuranceId || ''
      };
      let receiveObject = [];
      let messageCategory = this.form.messageCategory;
      this.receiverConfig[messageCategory].forEach(item => {
        var _item$selectValue;
        let obj = {
          type: item.formKey
        };
        if (item.btnCheck) {
          obj.userId = '';
        } else if (item.selectValue && item.selectValue.length > 0) {
          obj.userId = item.selectValue.join(',');
        }
        if (item.btnCheck || ((_item$selectValue = item.selectValue) === null || _item$selectValue === void 0 ? void 0 : _item$selectValue.length) > 0) {
          receiveObject.push(obj);
        }
      });
      eventConfig.receiveObject = receiveObject;
      return eventConfig;
    },
    getRemark() {
      //获取备注
      if (this.form.messageCategory === 'AUDIT_FLOW') {
        var _this$auditFlowList$f;
        let auditFlowLabel = (_this$auditFlowList$f = this.auditFlowList.find(item => item.id === this.form1.auditFlowId)) === null || _this$auditFlowList$f === void 0 ? void 0 : _this$auditFlowList$f.name;
        this.auditNodeLists.forEach(item => {
          if (this.form1.auditFlowNodeId.indexOf(item.id) !== -1) {
            auditFlowLabel = auditFlowLabel + '/' + item.name;
          }
        });
        return auditFlowLabel;
      } else if (this.form.messageCategory === 'INSURE' || this.form.messageCategory === 'SURRENDER_INSURANCE') {
        var _this$productList$fin;
        let remark = (_this$productList$fin = this.productList.find(item => item.id === this.form1.insuranceId)) === null || _this$productList$fin === void 0 ? void 0 : _this$productList$fin.name;
        return remark;
      }
    },
    getInternalMailFormData() {
      var _formData$title, _formData$fileContent;
      let formData = this.$refs.internalMailForm.form;
      let fileList = [];
      formData.fileList.forEach(item => {
        let obj = {
          name: item.name,
          url: item.url,
          uid: item.uid,
          status: item.status
        };
        fileList.push(obj);
      });
      fileList = fileList.length > 0 ? JSON.stringify(fileList) : '';
      let annexVariable = [];
      let attachmentVariable = this.$refs.internalMailForm.attachmentVariable;
      attachmentVariable.forEach(item => {
        if (item.isCheck) {
          annexVariable.push(item.mark);
        }
      });
      let params = {
        title: ((_formData$title = formData.title) === null || _formData$title === void 0 ? void 0 : _formData$title.trim()) || '',
        content: ((_formData$fileContent = formData.fileContent) === null || _formData$fileContent === void 0 ? void 0 : _formData$fileContent.trim()) || '',
        uploadFiles: fileList,
        type: 'INTERNAL_MAIL',
        annexVariable: (annexVariable === null || annexVariable === void 0 ? void 0 : annexVariable.length) > 0 ? annexVariable.join(',') : '',
        language: 'ZH',
        isSystemTemplate: 0,
        code: ''
      };
      if (this.isEdit && this.messageConfigIds.INTERNAL_MAIL) {
        params.sceneConfigId = this.messageConfigIds.INTERNAL_MAIL;
      }
      return params;
    },
    getNoteForm() {
      let formData = this.$refs.noteForm.form;
      let params = {
        title: formData.title,
        code: formData.code,
        content: formData.content,
        language: 'ZH',
        type: 'NOTE',
        isSystemTemplate: 0
      };
      if (this.isEdit && this.messageConfigIds.NOTE) {
        params.sceneConfigId = this.messageConfigIds['NOTE'];
      }
      return params;
    },
    getEmailForm() {
      var _formData$title2, _formData$content;
      let formData = this.$refs.emailForm.form;
      let fileList = [];
      formData.fileList.forEach(item => {
        let obj = {
          name: item.name,
          url: item.url,
          uid: item.uid,
          status: item.status
        };
        fileList.push(obj);
      });
      fileList = fileList.length > 0 ? JSON.stringify(fileList) : '';
      console.log(fileList, formData.fileList, 'fileList');
      let annexVariable = [];
      let attachmentVariable = this.$refs.emailForm.attachmentVariable;
      attachmentVariable.forEach(item => {
        if (item.isCheck) {
          annexVariable.push(item.mark);
        }
      });
      let params = {
        title: ((_formData$title2 = formData.title) === null || _formData$title2 === void 0 ? void 0 : _formData$title2.trim()) || '',
        content: ((_formData$content = formData.content) === null || _formData$content === void 0 ? void 0 : _formData$content.trim()) || '',
        uploadFiles: fileList,
        type: 'EMAIL',
        annexVariable: (annexVariable === null || annexVariable === void 0 ? void 0 : annexVariable.length) > 0 ? annexVariable.join(',') : '',
        language: 'ZH',
        isSystemTemplate: 0
      };
      if (this.isEdit && this.messageConfigIds.EMAIL) {
        params.sceneConfigId = this.messageConfigIds.EMAIL;
      }
      return params;
    },
    checkReceiveObject() {
      let flag = true;
      let messageCategory = this.form.messageCategory;
      this.receiverConfig[messageCategory].forEach(item => {
        var _item$selectValue2;
        if (item.btnCheck || ((_item$selectValue2 = item.selectValue) === null || _item$selectValue2 === void 0 ? void 0 : _item$selectValue2.length) > 0) {
          flag = false;
        }
      });
      if (this.form1.mobile || this.form1.email || this.form1.usersId.length > 0) {
        flag = false;
      }
      return flag;
    }
  }
};